import CheckContent from "components/atoms/CheckContent";
import Title from "components/atoms/Title";

export default function CardMakeDifferentV2({
  title,
  description,
  listWithIcon,
}) {
  return (
    <div className=" justify-center lg:col-12 lg:flex lg:flex-col">
      <div className="lg:pr-20">
        <Title
          as="h3"
          className=" mt-6 text-2xl font-semibold leading-9 text-bbc-brand-700 lg:mt-0 lg:text-bbc-30px"
        >
          {title}
        </Title>
        <div className="lg:text-normal mt-4">
          {Array.isArray(description) ? (
            description.map((item, idx) => {
              return (
                <div key={idx}>
                  <span className="font-semibold">{item.content}</span>
                  {item.listWithIcon ? (
                    <div className="mt-2 mb-6">
                      {item.listWithIcon.map((item, index) => {
                        return <CheckContent key={index} data={item} />;
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              );
            })
          ) : (
            <>
              {description}
              {listWithIcon ? (
                <div className="mt-3">
                  {listWithIcon.map((item, index) => {
                    return <CheckContent key={index} data={item} />;
                  })}
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
